<template>
  <div class="form-content">
    <div class="row align-center">
      <h2 class="form-footer__subtitle">Dados do titular</h2>
    </div>

    <div class="row">
      <FormControlInput
        class="col-12"
        icon="user"
        :value="items.name"
        label="Nome completo"
        id="name"
        name="name"
        data-vv-as="Nome completo"
        v-validate="'required'"
        :disabled="disabled"
      />
    </div>

    <div class="row">
      <FormControlMask
        class="col-6"
        :value="items.cpf"
        type="tel"
        label="CPF"
        id="cpf"
        name="cpf"
        data-vv-as="CPF"
        v-validate="{ required: true, regex: /\d{11}/ }"
        mask="###.###.###-##"
        :disabled="disabled"
      />

      <FormControlMask
        class="col-6"
        v-model="items.rg"
        label="RG"
        id="rg"
        name="rg"
        data-vv-as="RG"
        v-validate="'required'"
        mask="##.###.###-X"
        :disabled="disabled"
      />
    </div>

    <div class="row">
      <FormControlMask
        class="col-6"
        v-model="items.birth"
        type="tel"
        label="Data de Nascimento"
        id="birth"
        name="birth"
        data-vv-as="Data de Nascimento"
        v-validate="'required|date_format:dd/MM/yyyy'"
        :masked="true"
        mask="##/##/####"
        :disabled="disabled"
      />

      <FormControlSelect
        class="col-6"
        :value="items.gender"
        :options="gender"
        label="Sexo"
        id="gender"
        name="gender"
        data-vv-as="Sexo"
        v-validate="'required'"
        :disabled="disabled"
      />
    </div>

    <div class="row">
      <FormControlInput
        :value="items.email"
        id="email"
        type="email"
        name="email"
        class="col-6"
        label="E-mail"
        data-vv-as="E-mail"
        icon="envelope"
        v-validate="'required|email'"
        :disabled="disabled"
      />

      <FormControlMask
        :value="items.celphone"
        id="celphone"
        type="tel"
        class="col-6"
        label="Celular"
        data-vv-as="Celular"
        name="celphone"
        icon="phone-alt"
        mask="(##) #####-####"
        v-validate="'required'"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import FormControlMask from '../control/FormControlMask.vue';
import FormControlInput from '../control/FormControlInput.vue';
import FormControlSelect from '../control/FormControlSelect.vue';
import genderJson from '../../../data/gender.json';

export default {
  data() {
    return {
      gender: genderJson
    };
  },
  props: ['items', 'disabled'],
  components: {
    FormControlSelect,
    FormControlInput,
    FormControlMask
  }
};
</script>

<style></style>
